// eslint-disable-next-line
export default {
  primaire: 'rgb(5,27,113)',
  secondaire: 'rgb(54,154,212)',
  tertiaire: 'rgb(230,240,247)',
}